
export default () => ({
  isLoading: false,
  serviceLoaded: false,
  transfers: {
    isLoading: false,
    hasError: false,
    searchId: null,
    current: {
      name: null,
      slug: null,
      transferId: null,
      vehicleId: null,
      price: {
        amount: 0,
        markup: 0,
        currency: 'RUB',
      },
    },
    collection: [],
    errors: [],
  },
  form: {
    cityFrom: {
      slug: null,
      name: null,
    },
    placeFrom: {
      collection: [],
      current: null,
    },
    cityTo: {
      slug: null,
      name: null,
    },
    placeTo: {
      collection: [],
      current: null,
    },
    time: '10:00',
    returnTime: '10:00',
    checkInDate: null,
    checkOutDate: null,
    flightCode: null,
    flightNumber: null,
    returnFlightCode: null,
    returnFlightNumber: null,
    isRepeatedSearch: 0
  },
  penalties: {
    isLoading: true,
    hasError: false,
    collection: [],
    errors: []
  },
})
